module.exports = __webpack_public_path__ + "static/media/ic_05_flexibility.687dc35e.svg";